
import { store } from "../../../store/store"
import { USER_ID_KEY } from "../../../urls"
import {  customSendNotifyBody } from "../notify-helpers/customSendNotifyBody"



export const sendCustomNotification = async (   userID : number | string ,   title : string , text : string , url : string ): Promise<undefined> => {
    try {
        // const userAgent = navigator.userAgent
        // const isAndroid = _.includes(userAgent.toLowerCase(), 'android')
        // if (isAndroid) return
        const currentUserID = Number(window.localStorage.getItem(USER_ID_KEY)) 
        let receiverID = null
        let receiverDeviceToken = null

       
        if(currentUserID === userID ){
            receiverID = currentUserID
            receiverDeviceToken = store.getState().user.currentUser.DeviceToken
        } else {
            const user = store.getState().user.allUsers.filter((user) => user.id === Number(userID))[0]
            receiverID = user?.id
            receiverDeviceToken = user?.DeviceToken
        }
     
        await customSendNotifyBody({
            id: receiverID ,
            device : receiverDeviceToken,
            title,
            text,
            url,
            silent: false
        })
    } catch (err) {
        console.error('Error : ', err)
    }
}